/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

 import React from 'react';
import { connect } from 'react-redux';
import Agreement from '../components/Agreement';
import { onHandleAgreement } from '../state/action';
import { getMessage } from '../../../shared/containers/IntlProvider/state/actions';
import { sumbitApplication } from '../../AOFormReview/state/action';
import BasePage from '../../../shared/BasePage';
import { setTitle } from '../../../utils';

class AgreementContainer extends BasePage {

    componentDidMount = () => {
        this.loadContentMessage();
    }

    loadContentMessage = () => {
        this.props.getMessage('agreement', 'agreementContent')
    }

    render() {
        const { agreementContent, pageTitle } = this.props;

        if (agreementContent && pageTitle) {
          setTitle( agreementContent.legalContents.title + pageTitle);
        }

        return agreementContent ? <Agreement { ...this.props } /> : null
    }
}

const mapStateToProps = (state) => {
    const {
        app: { selectedLanguage, i18n: { pageTitle } },
        agreementReducer: { agreement },
        intl: { messages: { agreementContent } }
    } = state;
    return {
        agreement,
        agreementContent,
        selectedLanguage,
        pageTitle
    }
};

const mapDispatchToProps = {
    onHandleAgreement,
    getMessage,
    sumbitApplication
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AgreementContainer);


// WEBPACK FOOTER //
// ./src/views/Agreement/container/Agreement.js